import React, { memo } from 'react';

import CustomEmptyView from 'containers/components/CustomEmptyView';

import './styles.scss';

/**
 * Empty state for marketing email templates grid.
 * Wraps CustomEmptyView (EmptyScreen) so template-specific layout/CSS can evolve here.
 */
const TemplatesEmptyView = memo((props) => {
    return (
        <div className="marketing-templates-empty-view">
            <CustomEmptyView {...props} />
        </div>
    );
});

TemplatesEmptyView.displayName = 'TemplatesEmptyView';

export default TemplatesEmptyView;
